// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../bluecf-ui-classic-c9f3cc4a3eee/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabRow{padding:0px;margin-left:0px;margin-right:0px}.serversCol{overflow:auto;padding:0;box-sizing:border-box;box-shadow:5px 0 5px -5px #333;min-height:250px}.serverIcon{margin-right:5px}.firmwaresCol{overflow:auto;margin-right:0;height:250px}.modal-footer{margin-top:0px}", ""]);
// Exports
module.exports = exports;
